import styled from 'styled-components'

export const HeaderMenuWrapper=styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export const LeftMenuBox=styled.div`
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
`

export const RightMenuBox=styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
`

export const ContentWrapper=styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: var(--wh-348);
`

export const ChartWrapper=styled.div`
  width: 100%;
  height: var(--wh-348);
`

export const ChartMaskWrapper=styled.div`
  position: absolute;
  z-index: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  padding: 0 0 28px 17px;
  box-sizing: border-box;
  background: var(--white-85);

  width: calc(100% - 48px);
  height: var(--wh-348);

  @media (max-width: 768px) {
    padding: 0 0 28px 0;
    width: calc(100% - 24px);
  }
`